import tick_icon from "../../../../assets/tick_icon.svg";
import "./MudaCheckIcon.scss";
const MudaCheckIcon = () => {
  return (
    <div className="muda_check_icon_container">
      <div className="muda_check_icon_outer_ring">
        <div className="muda_check_icon_inner_ring">
          <img
            src={tick_icon}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default MudaCheckIcon;
